import React from 'react';
import {DMHintBlocked} from 'app/components/banner/DMHintBlocked';
import {useSelector} from 'react-redux';
import {selectCurrentUser} from 'app/hooks/reduxCreateSelectorHooks';
import {DMHintNotSupported} from 'app/components/banner/DMHintNotSupported';

const DMHintBanner = () => {
  const {pushSupport, notificationPermission} = useSelector(selectCurrentUser);

  let Hint = null;
  if (notificationPermission === 'denied') {
    Hint = <DMHintBlocked />;
  } else if (!pushSupport) {
    Hint = <DMHintNotSupported />;
  }
  return Hint;
};

export {DMHintBanner};
